import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import QrReader from 'modern-react-qr-reader';
import BarcodeScannerComponent from "react-qr-barcode-scanner";

// import AddCarnivalPopup from "./addCarnivalPopup";

const Scanner = ({ 
    fetchfdTicketList = null, 
    fdTicketLists = null, 
    match,
    history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCarnivalStatus, setCurrentcarnivalStatus] = useState('');
  const [carnivalId, setCarnivalId] = useState('');
  const [changeStatus, setChangeStatus] = useState(false);
  const [projectId, setProjectId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [result, setResult] = useState([]);
  const [data, setData] = React.useState("Not Found");


  const Headers = [
    'FreshDesk Id',
    'Created By',
    'Subject',
    'Priority',
    'Category',
    'Status',
    'Actions',
  ];

  useEffect(() => {
    if (fetchfdTicketList !== null)
      (async () => {
        setIsLoading(true);
        await fetchfdTicketList();
        setIsLoading(false);
      })();
  }, [fetchfdTicketList]);

  

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handleScan = data => {
    if (data) {
        setResult(data);
        console.log(result);
        
    }
  }
  
  const handleError = err => {
    console.error(err)
  }
  

  return (
    <Layout
      title={`Scanner`}
      // Buttons={headerBtns}
      isLoading={isLoading}
      linkFlag
    >
      {/* <QrReader
          delay={100}
          facingMode={"environment"}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '50%' }}
        /> */}
        <BarcodeScannerComponent
            width={500}
            height={500}
            onUpdate={(err, result) => {
              if (result) setData(result.text);
              else setData(err.text);
            }}
          />
          <p>{data}</p>
            
        {/* <p>{result}</p> */}
      
    </Layout>
  );
}; 

Scanner.propTypes = {
    fdTicketLists: PropTypes.any,
    fetchfdTicketList: PropTypes.func,
    match: PropTypes.any,
};

export default Scanner;
